module.exports = __webpack_public_path__ + "static/media/guess-note.f5ca73d8.png";